import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
} from '@angular/router';

import { AuthGuard } from './helpers/auth.guard';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LoginComponent } from './pages/login/login.component';
import {
  PostLoginLayoutComponent,
} from './pages/post-login-layout/post-login-layout.component';
import { RegisterComponent } from './pages/register/register.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    title: 'Sign in | PI Signage',
  },
  {
    path: 'register',
    component: RegisterComponent,
    title: 'Accept invitation | PI Signage',
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    title: 'Forgot password | PI Signage',
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    title: 'Reset password | PI Signage',
  },
  {
    path: '',
    component: PostLoginLayoutComponent,
    canActivate: [
      AuthGuard,
    ],
    children: [
      {
        path: 'devices',
        loadChildren: () => import('./modules/signage/signage.module')
          .then((module) => module.SignageModule),
      },
      {
        path: 'reports',
        loadChildren: () => import('./modules/reports/reports.module')
          .then((module) => module.ReportsModule),
      },
      {
        path: 'setting',
        loadChildren: () => import('./modules/setup/setup.module')
          .then((module) => module.SetupModule),
      },
      {
        path: '',
        loadChildren: () => import('./pages/pages.module')
          .then((module) => module.PagesModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {
}
